import request from '../../util/bpmRequest'

/**
 * 获取列表
 */
export function list(data) {
  return request({
    url: '/selectUser/list',
    method: 'post',
    data
  })
}
/**
 * 获取列表
 */
export function listByTaskSet(data) {
  return request({
    url: '/selectUser/listByTaskSet',
    method: 'post',
    data
  })
}

/**
 * 获取树形结构
 */
export function tree(data) {
  return request({
    url: '/selectUser/tree',
    method: 'post',
    data
  })
}
